import { Modal, Form, Upload, Row, Col, Select, Button, Card, Input, Typography, message } from "antd";
import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { AiOutlineDelete } from 'react-icons/ai';
import config from '../../config.json'
import "../../Styles/subtenant.css";
import Services from "../../network/Services";
import { useRef } from "react";
import { UserContext } from "../../App";
import Address from "../Address";
import commonLib from "../../control/commonLib";
import konsole from "../../network/konsole";
import PersonalInfo from "./PersonalInfo";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import TextArea from "antd/lib/input/TextArea";
import DeleteConfirmModal from "../DeleteConfirmModal";
import { isNullUndefine, isValidFuntion } from "../../control/Constant";
import Confirmation from "./Confirmation"


function AddSubtenantUsers({ visible, onCancel, getUserListApi, selectedSubtenant, subtenantValueSelected, setdisableselect, disabledselect, updatePartnerUsersData }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const { setLoader } = useContext(UserContext)
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [updateImage, setUpdateImage] = useState(false)
  const [updateSign, setUpdateSign] = useState(false)
  const [file, setFile] = useState();
  const [options, setOptions] = useState([])
  const [optionsBackUp, setOptionsBackUp] = useState([])
  const [subtenantId, setSubtenentId] = useState()
  const [speakerDetailsData, setSpeakerDetailsData] = useState()
  const [subtenantdata, setsubtenantdata] = useState([])
  const [getSubtenantRoleId, setGetSubtenantRoleId] = useState()
  const [deletedRoleName, setDeletedRoleName] = useState("")
  const [getMemberDetailsData, setGetMemberDetailsData] = useState()
  const [addressAPIStatus, setAddressAPIStatus] = useState()
  const [citizenship, setCitizenship] = useState([]);
  const [contactType, setContactType] = useState([]);
  const [getContactStatus, setGetContactStatus] = useState()
  const [countryCodeValue, setcountryCodeValue] = useState("+1")
  const createdBy = null;
  const isActive = true;
  const fileInputRef = useRef(null);
  const roleDropdownRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const cameraInputRef = useRef(null);
  const [openRoleDropdown, setOpenRoleDropdown] = useState(false);
  const [countrycode, setcountryCode] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [signatureData, setSignatureData] = useState()
  const [multiRole, setMultiRole] = useState([])
  const [multiRoleIdData, setMultiRoleIdData] = useState([])
  const [removeRoles, setRemoveRoles] = useState()
  let loginUserIdFromSession = sessionStorage.getItem('loggedUserId')
  const roleUserId = sessionStorage.getItem('roleUserId')
  const [closeModals, setCloseModals] = useState(false)
  const [roleRemoveinFilter, setroleRemoveinFilter] = useState()
  const [selectedSubtenantAddress, setSelectedSubtenantAddress] = useState(null)
  const { Option } = Select;
  const { Title } = Typography;
  let subtenantIds = sessionStorage.getItem('subtenantId')
  const[registeredEmailState,setregisteredEmailState]=useState(false)
   const [clientsEmail, setClientsEmail] = useState("")
   const [clientsEmailList, setClientsEmailList] = useState([])
   const [clientsEmailListChecked, setClientsEmailListChecked] = useState([])
   const [clientsEmailListCopy, setClientsEmailListCopy] = useState([])
   const[clientsUserId,setClientsUserId]=useState(null)
   const [clents_email_error, set_clents_email_error] = useState(false)
   const [registerdButDiffrentRole, setRegisterdButDiffrentRole] = useState(false)
   const [showConformationModal, setShowConformationModal] = useState(false)
   const [showImageModal, setShowImageModal] = useState(false);
   const [cameraStream, setCameraStream] = useState(null);
   const ConfirmationBodyContent="As consultation charges are not provided, the staff will not appear in the fee agreement."
   const [showFormData,setShowFormData]=useState({})
   const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    allRolesDetails()
    getCitizenship();
    getContactTypecode();
    setShowFormData({})
    setShowConformationModal(false)

  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (roleDropdownRef.current && !roleDropdownRef.current.contains(e.target)) {
        setOpenRoleDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (selectedSubtenant !== '') {
      form.setFieldsValue({ "subtenantName": selectedSubtenant })
    }
    /////////////  get Subtinent details /////////////

    Services.getsubtenantdetails(createdBy, isActive).then((res) => {
      const data = res?.data?.data
      setsubtenantdata(data)
      const activeSubtenantId = subtenantValueSelected || sessionStorage.getItem('subtenantId')

      if (activeSubtenantId && !(isValidFuntion(updatePartnerUsersData))) {
        const matched = data?.find(item => String(item.subtenantId) === String(activeSubtenantId))
        if (matched?.address) {
          const addr = matched.address
          setSelectedSubtenantAddress(addr)
          form.setFieldsValue({
            address: addr.addressLine1 || "",
            city: addr.city || "",
            state: addr.state || "",
            country: addr.country || "",
            zipcode: addr.zipcode || "",
          })
        }

    }
    }).catch((err) => {
    })

    //////////////   get country code //////////////////
    Services.getcountrycode().then((response) => {
      setcountryCode(response.data.data);
    }).catch((err) => {
      konsole.log("Error", err);
    });
  }, [])

  useEffect(() => {
    if (isValidFuntion(updatePartnerUsersData)) {
      let roleId = commonLib.getObjFromStorage('stateObj')?.roleId
      if (roleId != 4) {
        setdisableselect(true)
      }
      form.setFieldsValue({
        'email': updatePartnerUsersData?.userName,
        "charge" :updatePartnerUsersData?.userPrice,
        "wsbaNumber" :updatePartnerUsersData?.wsbaNumber
      })
      setClientsUserId(updatePartnerUsersData?.userId)
      getContactApiFunction(updatePartnerUsersData?.userId)
      getMemberAPiFunction(updatePartnerUsersData?.userId)
      getStaffAsClientAccountFun(updatePartnerUsersData?.userId)
    }
  }, [updatePartnerUsersData])

  async function getStaffAsClientAccountFun(staffAsClientUserId){
    let response= await Services.getStaffAsClientAccount(staffAsClientUserId,subtenantIds)
    response=await response?.data?.data
    if(response?.length>0){
     const updateResponseObj=response?.map((data)=>({
       "userFullName":data?.staffAsClientName ?? "",
       "emailId":data?.staffAsClientEmailId ?? "",
       "id":data?.staffAccountId,
        "staffUserId":data?.staffUserId,
       "staffAsClientUserId":data?.staffAsClientUserId,
       "staffAccountId":data?.staffAccountId
     }))
     setClientsEmailListChecked(updateResponseObj)
     setClientsEmailListCopy(updateResponseObj)
    }
   }


  const removeRolesFilter = (filtered, unfiltered) => {
    return unfiltered?.filter(ele => !filtered?.map(obj => obj).includes(ele));
  };


  const allRolesDetails = () => {
    const arr2 = ["1", "4", "2", "5", "9", "10", "12", "17", "18", "19", "20","23"];
    const roleId = commonLib.getObjFromStorage('stateObj')?.roleId;
    const subtenant = sessionStorage.getItem('subtenantId');
    Services.getAllUserRoleIdDetails().then((response) => {
      let filterData = response.data?.data?.filter(element => !arr2.includes(element.value));
      setOptionsBackUp(filterData);

      if (isValidFuntion(updatePartnerUsersData)) {
        getUserRoleFunction(updatePartnerUsersData?.userRgstrtnId, updatePartnerUsersData?.subtenantId, filterData, roleId, subtenant);
      } else {
        let filterLegalRoleData = [3, 13, 14, 15];
        if (roleId == 4 || subtenant == config.AOADMINSUBTENANTID) {
          filterData = filterData?.filter(x => !filterLegalRoleData.includes(parseInt(x.value)));
        }
        if(roleUserId == 4){
        filterData = filterData?.filter(x => x.value == 11);
        }
        setOptions(filterData);
        setOptionsBackUp(filterData);
      }
    }).catch((error) => {
      konsole.log("getAllUserRoleIdDetailserror", error);
    }).finally(() => {
      konsole.log("getAllUserRoleIdDetailsEnd");
    });
  }

  const getUserRoleFunction = (LoginUserId, SubtenantId, hideData, roleId, subtenant) => {
    Services.getUserRoleDetails(LoginUserId, SubtenantId).then(response => {
      const filterData = response.data.data?.map(items => items.roleId);
      setMultiRoleIdData(response.data.data);
      SepkaerListOptionApi(updatePartnerUsersData?.userId, filterData);

      const rolesToRemove = [10, 2, 1];
      rolesToRemove.forEach(role => {
        const index = filterData.indexOf(role);
        if (index !== -1) filterData.splice(index, 1);
      });

      const hideArrValue = [];
      const intersection = hideArrValue?.filter(x => !filterData.includes(x));
      let difference;

      if (intersection.length > 0) {
        hideArrValue.splice(hideArrValue.indexOf(intersection[0]), 1);
        hideData.forEach(disableFields => {
          if (hideArrValue.includes(disableFields.value)) {
            disableFields.disabled = true;
          }
        });

        difference = hideData?.filter(x => !hideArrValue.includes(parseInt(x.value)));
        if ((roleId == 4 && (subtenantValueSelected == config.AOADMINSUBTENANTID || subtenant == config.AOADMINSUBTENANTID)) ||
          (roleId != 4 && subtenant == config.AOADMINSUBTENANTID)) {
          difference = difference?.filter(x => ![3, 13, 14, 15].includes(parseInt(x.value)));
        }
        if(roleUserId == 4){
          difference = difference?.filter(x => x.value == 11);
        }
        setOptions(difference);
        setOptionsBackUp(difference);
      } else {
        difference = hideData;
        if ((roleId == 4 && (subtenantValueSelected == config.AOADMINSUBTENANTID || subtenant == config.AOADMINSUBTENANTID)) ||
          (roleId != 4 && subtenant == config.AOADMINSUBTENANTID)) {
          difference = difference?.filter(x => ![3, 13, 14, 15]?.includes(parseInt(x.value)));
        }
        if (roleUserId == 4) {
          difference = difference?.filter(x => x.value == 11);
        }
        setOptions(difference);
        setOptionsBackUp(difference);
      }

      setGetSubtenantRoleId(filterData);
      const allRoles = response.data.data.length > 0 && response.data.data?.map(items => items.roleId);
      setroleRemoveinFilter(removeRolesFilter(filterData, allRoles))
      form.setFieldsValue({ 'subtenantRole': filterData });
      setMultiRole(filterData);

      const legalGroup = [3, 13, 14, 15];
      const legalIntersection = legalGroup?.filter(x => filterData?.includes(x));
      if (legalIntersection?.length > 0) {
        const toDisable = legalGroup?.filter(x => x !== legalIntersection?.[0]);
        difference.forEach(opt => {
          if (toDisable?.includes(parseInt(opt.value))) {
            opt.disabled = true;
          }
        });
        if (roleUserId == 4) {
          difference = difference?.filter(x => x.value == 11);
        }
        setOptions([...difference]);
      }
    }).catch(error => {
      konsole.log("getUserRoleFunctionerror", error);
    }).finally(() => {
      konsole.log("getUserRoleFunctionEnd");
    });
  };

  const SepkaerListOptionApi = (userId, roleIdData) => {
    Services.getPartnerUserSpeakerDetailsList(userId, true).then((response) => {
      let responseData = response.data?.data?.speakers[0]
      setSpeakerDetailsData(responseData)
      form.setFieldsValue({
        'speakerLink': responseData?.videoLinkPath,'speakerDescription': responseData?.speakerProfile,
      })
      if (isValidFuntion(responseData?.speakerProfileUrl) && roleIdData.includes(7)) {
        setFileList([{ uid: '-1', name: 'image.png', status: 'done', url: responseData?.speakerProfileUrl }])
      }
    }).catch((error) => {
      konsole.log("ErrorSpeakerList", error);
    });
  };

  const getCitizenship = () => {
    Services.getCitizenshipType().then((res) => {
      setCitizenship(res.data.data);
    }).catch((err) => {
      konsole.log(err);
    });
  };

  const getContactTypecode = () => {
    Services.getContactType().then((res) => {
      setContactType(res.data.data);
    }).catch((err) => {
      konsole.log(err);
    });
  };

  const getContactApiFunction = (userId) => {
    Services.getContactDetails(userId).then((response) => {
      let responseData = response.data?.data
      setGetContactStatus(responseData)
      let fullMobileNo = responseData?.contact?.mobiles[0]?.mobileNo || ""
      let digitsOnly = fullMobileNo.startsWith("+") ? fullMobileNo.slice(1) : fullMobileNo
      let localNumber = digitsOnly?.slice(-10)
      let dialCodeDigits = digitsOnly.slice(0, digitsOnly?.length - 10)
      let savedCountryCode = dialCodeDigits ? "+" + dialCodeDigits : "+1"
      setcountryCodeValue(savedCountryCode)
      form.setFieldsValue({ 'mobile': digitsOnly, 'number': localNumber })
    }).catch((error) => {
      konsole.log("getContactDetailsError", error)
    }).finally(() => {
      konsole.log("getContactDetailsEnd")
    })
  }

  const getMemberAPiFunction = async (userId) => {
    Services.getMemberDetails(userId).then(async (response) => {
      const memberData = response.data?.data?.member;
      setGetMemberDetailsData(memberData)

      if (isValidFuntion(memberData?.signatureId)) {
        const signatureFileData = { primaryUserId: memberData?.userId, fileId: memberData.signatureId, fileTypeId: 63, fileCategoryId: 1, requestedBy: loginUserIdFromSession };
        const signatureResult = await getFileDetails(signatureFileData);
        setImageUrl(signatureResult === 'err' ? null : signatureResult?.fileUrlPath);
        setSignatureData(signatureResult === 'err' ? null : signatureResult);
      }

      if (isValidFuntion(memberData?.fileId)) {
        const imageFileData = { primaryUserId: memberData?.userId, fileId: memberData.fileId, fileTypeId: 15, fileCategoryId: 1, requestedBy: loginUserIdFromSession };
        const imageResult = await getFileDetails(imageFileData);
        setFileList([{ uid: '-1', name: 'image.png', status: 'done', url: imageResult === 'err' ? null : imageResult?.fileUrlPath }]);
        setFile([{ uid: '-1', name: 'image.png', status: 'done', url: imageResult === 'err' ? null : imageResult?.fileUrlPath }]);
        stopCamera();
      }
    }).catch((error) => {
      konsole.log("getMemberAPiFunctionError", error);
    }).finally(() => {
      konsole.log("getContactDetailsEnd");
    });
  };

  const getFileDetails = (openFileInfo) => {
    return new Promise((resolve, reject) => {
      setLoader(true)
      Services.getFileForView({ ...openFileInfo }).then((res) => {
        setLoader(false)
        resolve(res?.data?.data)
        setLoader(false)

      }).catch((err) => {
        setLoader(false)
        resolve('err')
      })

    })

  }

  function addEditJsonFun(action) {
    if (clientsUserId == null) return
    try {
      if (action == "Update") {
        clientsEmailListCopy?.map(async (dataValue) => {
          let jsonForStaffClient = {
            "staffAccountId": dataValue.staffAccountId,
            "staffUserId": clientsUserId,
            "staffAsClientUserId": dataValue.staffAsClientUserId,
            "isActive": false,
            "subtenantId": subtenantIds,
            "createdBy": loginUserIdFromSession
          }
          await upsertStaffClient(jsonForStaffClient)
        })
      }

      clientsEmailListChecked?.forEach(async (dataValue) => {
        let jsonForStaffClient = {
          "staffAccountId": 0,
          "staffUserId": clientsUserId,
          "staffAsClientUserId": dataValue.staffAsClientUserId,
          "isActive": true,
          "subtenantId": subtenantIds,
          "createdBy": loginUserIdFromSession
        }
        await upsertStaffClient(jsonForStaffClient)
      })
      return
    } catch (err) {
      // console.error("err_addUpdateStaff", err)
    }
  }

  function arrayComparisonFun(array1, array2) {
    if (array1?.length !== array2?.length) return false
    return array1?.every((value1, index) => value1?.staffAsClientUserId == array2[index]?.staffAsClientUserId)
  }

  async function addUpdateStaff() {
    if (clientsEmailListCopy?.length == 0 && clientsEmailListChecked?.length > 0) {
      addEditJsonFun("Add")
    } else if (clientsEmailListCopy?.length > 0) {
      const checkBothArraysSame = arrayComparisonFun(clientsEmailListCopy, clientsEmailListChecked)
      if (!checkBothArraysSame) {
        addEditJsonFun("Update")
      }
      return
    } else if (clientsEmailListCopy?.length == 0 && clientsEmailListChecked?.length == 0) {
    }
    return
  }

  function ConsultationConfirm(value) {
    setShowConformationModal(false)
    if (value == true) {
      callSubmitAPiFun()
    }
  }

  function callSubmitAPiFun() {
    if (showFormData?.length == 0) return
    if (submitting) return;        // guard against rapid double-click
    setSubmitting(true);           // disable button immediately

    if (isValidFuntion(updatePartnerUsersData)) {
      const formData = form.getFieldsValue();
      const currentRoles = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : [];
      const intersectionData = multiRole?.filter(element => !currentRoles?.includes(element));
      let removedObjects = multiRoleIdData?.filter(obj => !currentRoles?.includes(obj.roleId));

      if (roleRemoveinFilter.length > 0 && removedObjects.length > 0) {
        removedObjects = removedObjects?.filter(obj => !roleRemoveinFilter?.includes(obj.roleId));
      }

      if (removedObjects.length > 0) {
        setRemoveRoles(removedObjects)
        const rolesArray = intersectionData?.map(roleId => multiRoleIdData.find(data => data.roleId === roleId)?.roleKey);
        const deletedRoleToString = rolesArray.join(", ");
        setDeletedRoleName(deletedRoleToString);
      }
      addUpdateStaff()
      upDateAllData(removedObjects)  // try/catch inside upDateAllData handles setSubmitting(false)
    } else {
      callAddUserApi(showFormData);  // PostNewUser .catch handles setSubmitting(false)
    }
  }

  const onFinishForm = async (data) => {
    setShowFormData(data)
    if (((getSubtenantRoleId || [])?.some(role => [3, 13, 14, 15].includes(role))
      && (form?.getFieldValue()?.charge == undefined || form?.getFieldValue()?.charge?.length == 0))) {
      // Reset submitting so the confirmation modal flow isn't blocked
      setSubmitting(false)
      setShowConformationModal(true)
    } else {
      callSubmitAPiFun()
    }
  }

  const onSearch = (value) => { };

  const handleProfileChange = ({ fileList: newFileList }) => {
    if (isValidFuntion(updatePartnerUsersData)) {
      setUpdateImage(true)
    }
    if (newFileList?.length > 0) {
      const isJpgOrPng = newFileList[0].type === "image/jpeg" || newFileList[0].type === "image/png";
      if (!isJpgOrPng) return;
    }
    setFileList(newFileList);
    setFile(newFileList[0]?.originFileObj);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return;
    }
    const isLt2M = file.size / 1024 / 1024 > 1;
    if (isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  const onSelectLifePointLaw = (e, key) => {
    let filterLegalRoleData = [3, 13, 14, 15]
    let subtenantValue = key.key
    form.setFieldsValue({ 'subtenantRole': undefined })
    setGetSubtenantRoleId([])

    if (subtenantValue == config.AOADMINSUBTENANTID) {
      let difference = options?.filter(x => !filterLegalRoleData?.includes(parseInt(x.value)));
      if (roleUserId == 4) {
        difference = difference?.filter(x => x.value == 11);
      }
      setOptions(difference)
    } else {
      if (roleUserId == 4) {
        const data = optionsBackUp?.filter(x => x.value == 11);
        setOptions(data)
      } else {
        setOptions(optionsBackUp)
      }
    }
    setSubtenentId(key.key)

    const matchedSubtenant = subtenantdata?.find(data => String(data.subtenantId) === String(key.key))
    const addr = matchedSubtenant?.address || null
    setSelectedSubtenantAddress(addr)
    if (addr) {
      form.setFieldsValue({
        address: addr.addressLine1 || "",
        city: addr.city || "",
        state: addr.state || "",
        country: addr.country || "",
        zipcode: addr.zipcode || "",
      })
    }
  }

  const onChangePhone = (value, country) => {
    const dialCode = country?.dialCode || "1";
    const fullNumber = "+" + value;
    setcountryCodeValue("+" + dialCode);
    form.setFieldsValue({ mobile: value });
  };

  const getSubtenantId = (e) => {
    setGetSubtenantRoleId(e)
    let hideArrValue = [3, 13, 14, 15]
    let intersection = hideArrValue?.filter(x => e.includes(x));

    if (intersection.length > 0) {
      hideArrValue.splice(hideArrValue.indexOf(intersection[0]), 1)
      for (let i = 0; i < hideArrValue.length; i++) {
        options?.filter((disableFields) => {
          if (disableFields.value == hideArrValue[i]) {
            disableFields['disabled'] = true
          }
        })
      }
    } else {
      for (let i = 0; i < hideArrValue.length; i++) {
        options?.filter((disableFields) => {
          if (disableFields.value == hideArrValue[i]) {
            disableFields['disabled'] = false
          }
        })
      }
    }
  }

  const handleDeleteSign = () => {
    setImageUrl(null);
    setSignatureData(null)
    if (isValidFuntion(updatePartnerUsersData)) {
      setUpdateSign(true)
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (isValidFuntion(updatePartnerUsersData)) {
      setUpdateSign(true)
    }
    setSignatureData(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const deletestatus = (data) => {
    if (data == true) {
      addorUpdateUserRoles()
    } else if (data == false) {
      onCancel()
      getUserListApi()
    }
  }

  const callAddUserApi = (data) => {
    const { fName, lName, email, mobile, subtenantName, mName, charge } = form.getFieldsValue()
    const subtenantRole = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : []
    const subtenantId = subtenantdata.find(data => data.subtenantName === subtenantName)?.subtenantId;
    const userId = sessionStorage.getItem("loggedUserId");
    setLoader(true);
    const dialCodeDigits = countryCodeValue?.replace("+", "") || "1";
    const mobileNumber = mobile?.startsWith(dialCodeDigits) ? mobile.slice(dialCodeDigits?.length) : mobile;
    const jsonObjData = {
      subtenantId,
      signUpPlateform: config.AOADMIN,
      createUserCredentials: false,
      createdBy: userId,
      user: {
        roleId: parseInt(subtenantRole[0]),
        firstName: fName,
        mName: mName,
        lastName: lName,
        emailAddress: email,
        userName: email,
        countryCode: countryCodeValue,
        mobileNumber: mobileNumber,
        packageCode: null,
        activateUser: false,
        autoConfirmEmail: false,
        autoConfirmMobile: false,
        userPrice: charge
      }
    };
    PostNewUser(jsonObjData, data);
  };

  const PostNewUser = async (jsonObjData, data) => {
    const postAddUserApiCall = Services.subtenantCreateUser(jsonObjData);
    return postAddUserApiCall.then(async (res) => {
      message.success("Firm User created Successfully");
      const formdata = form.getFieldsValue();
      const subtenantId = subtenantdata.find(data => data.subtenantName === formdata.subtenantName)?.subtenantId;

      if ((Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : []).length > 1) {
        const rolesFromState = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : [];
        for (let i = 1; i < rolesFromState.length; i++) {
          const response = res?.data?.data;
          await multiRoleAPIFunction(response?.userId, response?.id, subtenantId, rolesFromState[i], true, response?.createdBy);
        }
      }

      const createdBy = res.data.data.createdBy;
      const userId = res.data.data.userId;
      const fileId = isValidFuntion(file) ? await fileSignupload(file, createdBy, userId, 15, 1, 2) : null;
      const signatureId = isValidFuntion(signatureData) ? await fileSignupload(signatureData, createdBy, userId, 63, 1, 2) : null;

      if ((Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : []).includes(7)) {
        await postspekaeruser(0, userId, form?.getFieldValue()?.speakerDescription, form?.getFieldValue()?.speakerLink, fileId, "Done", true, createdBy, signatureId);
      }
      await updateMemberDataByID(userId, fileId || "", signatureId || "");

      const cleintUserIdsList = clientsEmailListChecked?.map(dataValue => dataValue?.userId);
      cleintUserIdsList?.forEach(async (data) => {
        let jsonForStaffClient = {
          "staffAccountId": 0,
          "staffUserId": userId,
          "staffAsClientUserId": data,
          "isActive": true,
          "subtenantId": subtenantIds,
          "createdBy": loginUserIdFromSession,
        }
        await upsertStaffClient(jsonForStaffClient)
      })
      getUserListApi()
      onCancel()
    }).catch((error) => {
      if (error.response.data.messages[0] === "ALREADY_REGISTERED") {
        message.error(error.response.data.messages[1]);
      }
      setSubmitting(false);   // ← re-enable on API error (Add flow)
    }).finally(() => {
      setLoader(false);
    });
  };

  const multiRoleAPIFunction = (userId, loginUserId, subtenantId, roleId, isActive, createdBy) => {
    setLoader(true)
    return new Promise((resolve, reject) => {
      Services.postRoleIdData(userId, loginUserId, subtenantId, roleId, isActive, createdBy).then((res) => {
        resolve(res)
      }).catch((err) => {
        resolve('err')
        setLoader(false)
      })
    })
  }

  const fileSignupload = (file, createdBy, userId, fileTypeId, fileCategoryId, fileStatusId) => {
    return new Promise((resolve, reject) => {
      Services.postfileuploadspeaker(file, createdBy, userId, fileTypeId, fileCategoryId, fileStatusId).then((res) => {
        let response = res?.data?.data?.fileId
        resolve(response)
        setFile(null)
      }).catch((err) => {
        resolve('err')
      })
    })
  };

  const upsertStaffClient = (jsonForStaffClient) => {
    return new Promise((resolve, reject) => {
      Services.upsertStaffClient(jsonForStaffClient).then((res) => {
        let response = res?.data?.data
        resolve(response)
      }).catch((err) => {
        resolve('err')
      })
    })
  };

  const updateMemberDataByID = (userId, fileId, signatureId) => {
    setLoader(true)
    const { fName, lName, email, mobile, subtenantName, dob, Citizenship, genderId, mName, charge, wsbaNumber } = form.getFieldsValue()
    const subtenantRole = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : []
    const updatedBy = sessionStorage.getItem("loggedUserId");
    const subtenantId = subtenantdata?.filter((data, index) => { return data.subtenantName == subtenantName })[0]?.subtenantId
    let jsondata = {
      subtenantId: subtenantId, fName: fName, mName: mName, lName: lName, fileId: fileId ?? null, userPrice: charge, wsbaNumber: wsbaNumber,
      signatureId: signatureId ?? null, dob: isValidFuntion(dob) && dob !== false ? moment(dob).format("YYYY-MM-DD") : "",
      citizenshipId: Citizenship, genderId: genderId, userId: userId, updatedBy: updatedBy
    }
    return new Promise((resolve, reject) => {
      Services.subtenantmemberbyuserid(jsondata).then((res) => {
        if (!isValidFuntion(updatePartnerUsersData)) {
          addressByUserId(userId);
        }
        setLoader(false)
        resolve(res)
      }).catch((err) => {
        konsole.log("errerr", err)
        resolve('err')
        setLoader(false)
      }).finally(() => {
        setLoader(false)
      })
    })
  };

  const postspekaeruser = async (speakerUserId, userId, speakerProfile, videoLinkPath, speakerImageId, remarks, isActive, upsertedBy, speakersignId) => {
    return new Promise((resolve, reject) => {
      Services.postspeakerupsertuser(speakerUserId, userId, speakerProfile, videoLinkPath, speakerImageId, remarks, isActive, upsertedBy, speakersignId).then((res) => {
        resolve(res)
      }).catch((err) => {
        resolve('err')
      }).finally(() => { })
    })
  };

  const addressByUserId = (userId, deleteRolesStatus) => {
    const { address, zipcode, country, city, state } = form.getFieldsValue();
    const subtenantRole = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : []
    const createdBy = sessionStorage.getItem("loggedUserId");

    let addressjson = {
      userId: userId,
      address: {
        lattitude: "string",
        longitude: "string",
        addressLine1: address,
        addressLine2: "string",
        addressLine3: "string",
        zipcode: zipcode,
        county: country,
        city: city,
        state: state,
        country: country,
        addressTypeId: 1,
        createdBy: createdBy,
      }
    }

    Services.addAddressByuserId(addressjson).then((res) => {
      setLoader(false)
    }).catch((err) => {
      konsole.log("errassress", err)
      message.error("Enter valid details")
      setLoader(false)
    }).finally(() => {
      setLoader(false)
    })
  }

  const addorUpdateUserRoles = async () => {
    let formData = form.getFieldsValue()
    const subtenantRoleForRoles = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : []
    const subtenantId = subtenantdata?.filter((data, index) => { return data.subtenantName == formData.subtenantName })[0]?.subtenantId
    if (removeRoles?.length > 0 && subtenantRoleForRoles?.length > 0) {
      setLoader(true)
      for (let i = 0; i < removeRoles.length; i++) {
        let result = await putRolesDetailsData(removeRoles?.[0]?.loginUserId, subtenantId, removeRoles[i]?.roleId, false, removeRoles[i]?.userRoleId, loginUserIdFromSession, "")
        if (i == removeRoles.length - 1 && closeModals == true) {
          removeRoles.length = 0;
          message.success("Updated Successfully");
          setShowDeleteModal(false)
          setLoader(false)
          getUserListApi()
          onCancel()
        }
      }
    }
  };

  const putRolesDetailsData = (loginUserId, subtenantId, roleId, isActive, userRoleId, loginUserIdFromSession, extraParam) => {
    return new Promise((resolve, reject) => {
      Services.putRoleIdDetails(loginUserId, subtenantId, roleId, isActive, userRoleId, loginUserIdFromSession, extraParam).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      }).finally(() => { });
    });
  };

  const upDateAllData = async (removedObjects) => {
    try {
      if (isValidFuntion(updatePartnerUsersData)) {
        const { fName, mName, lName, genderId, Citizenship, dob, mobile, subtenantName,
          number, address, zipcode, city, state, country, charge, wsbaNumber } = form.getFieldsValue()
        const subtenantRole = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : []
        const subtenantId = subtenantdata?.filter((data, index) => { return data.subtenantName == subtenantName })[0]?.subtenantId
        let mobileNumber = "+" + mobile;

        if (updatePartnerUsersData?.primaryMobile !== mobileNumber) {
          let promise = Services.putContactDetails(
            getContactStatus?.userId, 1,
            getContactStatus?.contact?.mobiles[0]?.contactTypeId,
            mobileNumber,
            getContactStatus?.contact?.mobiles[0]?.contactId,
            loginUserIdFromSession
          )
          promise.then((res) => {
            konsole.log("putContactDetails", res)
          }).catch((err) => {
            konsole.log("putContactDetailserr", err)
          }).finally(() => { })
        }

        if (isValidFuntion(addressAPIStatus?.addressLine1)) {
          if (addressAPIStatus?.addressLine1 !== address) {
            Services.putAddressDetails(
              address, zipcode, city, state, country,
              addressAPIStatus?.addressTypeId, addressAPIStatus?.addressId,
              loginUserIdFromSession, true
            ).then((response) => {
            }).catch((error) => {
              konsole.log("putAddressDetailsError", error)
            }).finally(() => {
              konsole.log("putAddressDetailsEnd")
            })
          }
        } else {
          addressByUserId(updatePartnerUsersData?.userId)
        }

        const isValidDob = isValidFuntion(getMemberDetailsData?.dob) === true ? getMemberDetailsData?.dob.substr(0, 10) : null;
        const dobValue = isValidFuntion(dob) === true && dob !== false ? dob.substr(0, 10) : null;

        if (getMemberDetailsData?.fName !== fName || getMemberDetailsData?.mName !== mName ||
          getMemberDetailsData?.lName !== lName || isValidDob !== dobValue ||
          getMemberDetailsData?.genderId !== genderId ||
          getMemberDetailsData?.citizenshipId !== Citizenship || updateSign || updateImage ||
          subtenantRole?.includes(7) ||
          getMemberDetailsData?.userPrice !== charge || getMemberDetailsData?.wsbaNumber !== wsbaNumber) {

          let fileId = null;
          let signatureId = null;

          if (isValidFuntion(file) && updateImage) {
            fileId = await fileuploadForUpdate(file, loginUserIdFromSession, updatePartnerUsersData?.userId, 15, 1, 2);
          }
          if (isValidFuntion(signatureData) && updateSign) {
            signatureId = await fileuploadForUpdate(signatureData, loginUserIdFromSession, updatePartnerUsersData?.userId, 63, 1, 2);
          }

          if (subtenantRole?.includes(7)) {
            const files = fileId || (isValidFuntion(file) ? getMemberDetailsData?.fileId : null);
            const sign = signatureId || (isValidFuntion(signatureData) ? getMemberDetailsData?.signatureId : null);
            await putSpekaeruser(files, sign);
            await updateMemberDataByID(updatePartnerUsersData?.userId, files, sign);
          } else {
            const files = fileId || (isValidFuntion(file) ? getMemberDetailsData?.fileId : null);
            const sign = signatureId || (isValidFuntion(signatureData) ? getMemberDetailsData?.signatureId : null);
            await updateMemberDataByID(updatePartnerUsersData?.userId, files, sign);
          }
        }

        let addedObjects = subtenantRole?.filter(id => !multiRoleIdData.some(obj => obj.roleId === id));
        if (addedObjects.length > 0) {
          for (let i = 0; i < addedObjects.length; i++) {
            let reasult = await multiRoleAPIFunction(
              updatePartnerUsersData?.userId, updatePartnerUsersData?.userRgstrtnId,
              subtenantId, addedObjects[i], true, loginUserIdFromSession
            )
            if (i == addedObjects.length - 1) {
              addedObjects.length = 0;
              setLoader(false)
            }
          }
        }
      }

      if (showDeleteModal == false && removedObjects.length == 0) {
        getUserListApi()
        message.success("Updated Successfully")
        onCancel()
      } else {
        setCloseModals(true)
        setShowDeleteModal(true);
      }

    } catch (err) {
      // ← catches any unexpected throw from awaited calls in Update flow
      konsole.log("upDateAllData error", err)
      message.error("Something went wrong. Please try again.")
      setSubmitting(false)   // ← re-enable button on error (Update flow)
    }
  }

  const fileuploadForUpdate = (file, loginUserIdFromSession, createdByuserId, fileTypeId, fileCategoryId, fileStatusId) => {
    setLoader(true)
    return new Promise((resolve, reject) => {
      Services.postfileuploadspeaker(file, loginUserIdFromSession, createdByuserId, fileTypeId, fileCategoryId, fileStatusId).then((res) => {
        let fileId = res.data.data.fileId
        resolve(fileId)
        setLoader(false)
        setUpdateImage(false)
        setUpdateSign(false)
      }).catch((err) => {
        resolve('err')
        setLoader(false)
      })
    })







  }

  const putSpekaeruser = (fileId, signatureId) => {
    setLoader(true)
    const { speakerDescription, speakerLink } = form.getFieldsValue()
    return new Promise((resolve, reject) => {
      Services.postspeakerupsertuser(speakerDetailsData?.speakerUserId, updatePartnerUsersData?.userId, speakerDescription, speakerLink, fileId, "Done", true, loginUserIdFromSession, signatureId).then((res) => {
        resolve(res)
        setLoader(false)
      }).catch((err) => {
        resolve('err')
      }).finally(() => { })
    })
  }

  const [selectedTab, setSelectedTab] = useState("preview");
  const [compModel, setCompModel] = useState("baseBonus");
  const subtenantRole = Array.isArray(getSubtenantRoleId) ? getSubtenantRoleId : [];

  const styles = {
    container: { maxWidth: "1100px", margin: "20px auto", fontFamily: "Arial, sans-serif" },
    card: { background: "#fff", borderRadius: "6px", marginBottom: "20px" },
    formGroup: { marginBottom: "16px" },
    label: { display: "block", marginBottom: "6px", fontWeight: "bold", fontSize: "14px" },
    selectInput: { width: "100%", padding: "10px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "14px" },
    compModel: { border: "1px solid #ccc", padding: "15px", borderRadius: "6px", marginBottom: "20px" },
    compLabel: { fontWeight: "bold", marginBottom: "10px", fontSize: "14px" },
    radioGroup: { display: "flex", gap: "20px", flexWrap: "wrap", fontSize: "14px" },
    infoBox: { backgroundColor: "#f0f0f0", borderLeft: "4px solid #8B0000", padding: "12px", fontSize: "13px", color: "#333" },
    buttonGroup: { display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" },
    underline: { textDecoration: "underline" },
  };

  const getEmailsList = (emailIds) => {
    setLoader(true)
    return new Promise((resolve, reject) => {
      Services.getClientsEmail(emailIds).then((res) => {
        resolve(res)
        setLoader(false)
      }).catch((err) => {
        resolve('err')
        setLoader(false)
      })
    })
  }

  function cleintsEmailFun(event) {
    const eventValue = event?.target?.value?.trim();
    setClientsEmail(eventValue)
    const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/.test(eventValue);
    if (!isValid) {
      set_clents_email_error(!isValid)
      return
    }
    set_clents_email_error(!isValid)
  }

  function removeEmailContent(event) {
    const eventId = event?.target?.id;
    if (eventId == "crossIcon") {
      setClientsEmail("")
      set_clents_email_error(false)
    }
  }

  async function callEmailGetApiFun() {
    let smailApiResonse = await getEmailsList(clientsEmail)
    if (smailApiResonse == "err") return
    smailApiResonse = smailApiResonse?.data;
    if (smailApiResonse?.length == 0) {
      setClientsEmailList([])
      setregisteredEmailState(true)
    }
    if (smailApiResonse?.length > 0) {
      let filterForRoleIds = smailApiResonse?.filter(data => {
        return data?.roleDetails?.some((value) => ((value?.roleId == 1 || value?.roleId == 9 || value?.roleId == 10)))
      })
      filterForRoleIds = filterForRoleIds || [];
      if (filterForRoleIds?.length == 0) { setRegisterdButDiffrentRole(true) }
      if (filterForRoleIds?.length > 0) {
        filterForRoleIds = filterForRoleIds?.filter(data => data?.subtenantId == subtenantIds);
        filterForRoleIds = filterForRoleIds?.map((data) => ({ ...data, checked: false, "staffAsClientUserId": data?.userId }))
      }
      setClientsEmailList(filterForRoleIds)
    }
  }

  function onKeyDownEvent(event) {
    setregisteredEmailState(false)
    setRegisterdButDiffrentRole(false)
    if (event.key === 'Enter') {
      event.preventDefault();
      if ((clientsEmail?.length == 0) || (clents_email_error && clientsEmail?.length > 0)) return
      callEmailGetApiFun()
    }
  }

  function SearchClientsEmail() {
    const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/.test(clientsEmail);
    if (!isValid) {
      set_clents_email_error(!isValid)
      return
    }
    set_clents_email_error(!isValid)
    callEmailGetApiFun()
  }

  function selectStaffEmail(event, data) {
    const eventId = event.currentTarget.id;
    event.preventDefault();
    setClientsEmailListChecked(prev => {
      if (!prev.some((value) => value.staffAsClientUserId == eventId)) {
        let modifiedData = { ...data, "staffAsClientUserId": data.userId, "staffAccountId": 0 }
        return ([modifiedData, ...prev])
      }
      return prev
    })
    setClientsEmail("")
  }

  function removeCheckedStaff(event, data) {
    event.preventDefault();
    setClientsEmailListChecked(prev => {
      return prev.filter((value) => value.id != data.id)
    })
  }

  useEffect(() => {
    if (cameraStream && videoRef.current) {
      videoRef.current.srcObject = cameraStream;
    } else if (!cameraStream && videoRef.current) {
      videoRef.current.srcObject = null;
    }
  }, [cameraStream]);

  const openImageModal = () => setShowImageModal(true);

  const closeImageModal = () => {
    stopCamera();
    setShowImageModal(false);
  };

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } });
      setCameraStream(stream);
    } catch (err) {
      message.error("Camera access denied or not available.");
    }
  };

  const stopCamera = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
    }
    setCameraStream(null);
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  const takeSelfie = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (!video || !canvas) return;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);

    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setCameraStream(null);

    canvas.toBlob((blob) => {
      const selfieFile = new File([blob], "selfie.png", { type: "image/png" });
      const previewUrl = URL.createObjectURL(blob);
      setFileList([{ uid: '-1', name: 'selfie.png', status: 'done', url: previewUrl }]);
      setFile(selfieFile);
      if (isValidFuntion(updatePartnerUsersData)) setUpdateImage(true);
    }, 'image/png');
  };

  const handleGalleryUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    const isJpgOrPng = selectedFile.type === "image/jpeg" || selectedFile.type === "image/png";
    if (!isJpgOrPng) { message.error("Only JPG/PNG allowed!"); return; }
    if (selectedFile.size / 1024 / 1024 > 2) { message.error("Image must be smaller than 2MB!"); return; }
    const previewUrl = URL.createObjectURL(selectedFile);
    setFileList([{ uid: '-1', name: selectedFile.name, status: 'done', url: previewUrl }]);
    setFile(selectedFile);
    if (isValidFuntion(updatePartnerUsersData)) setUpdateImage(true);
    setShowImageModal(false);
  };

  return (
    <>
      <Modal visible={visible} enforceFocus={false}
        okText="Add" onCancel={onCancel} footer={null} closable={false} centered={true} maskClosable={false}
        width={1000}
        style={{ top: 20 }}
        bodyStyle={{ padding: '0px', maxHeight: 'calc(100vh - 80px)', overflowY: 'auto', borderRadius: '8px' }}
      >
        {/* Custom header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px 12px 16px', borderBottom: '1px solid #bfbfbf' }}>
          <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>
            {(updatePartnerUsersData !== null && updatePartnerUsersData !== undefined && updatePartnerUsersData !== "") ? "Edit User" : "Add New User"}
          </p>
          <span onClick={onCancel} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
        </div>

        <div style={{ border: '1.5px dashed #720C20', borderRadius: '10px', padding: '16px', margin: '24px 16px 16px 16px' }}>
          <Form form={form} name="AdduserForm" style={{ width: "100%", marginTop: "0px", paddingRight: "5px" }}
            wrapperCol={{ span: 24 }} labelCol={{ span: 0 }} className="w-100" layout="inline" onFinish={onFinishForm}>

            <Row lg={24} className="w-100 d-flex justify-content-between" style={{ marginTop: "10px" }}>
              <Col span={6} xs={10} md={6} lg={6}>
                <Form.Item name="fileUpload">
                  {(() => {
                    const boxStyle = { width: "200px", height: "150px", border: "1.5px dashed #720C20", borderRadius: "10px", background: "#fff", boxSizing: "border-box" };
                    const btnRowStyle = { display: "flex", alignItems: "center", gap: "8px", padding: "8px", border: "1px solid rgb(221, 221, 221)", borderRadius: "8px", cursor: "pointer", background: "#fafafa", flex: 1, maxHeight: "60px" };
                    const iconBoxStyle = { width: "32px", height: "32px", borderRadius: "6px", background: "#f9eaea", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 };

                    if (fileList?.length > 0 && fileList?.[0]?.url) return (
                      <div style={{ ...boxStyle, position: "relative", overflow: "hidden", padding: "6px" }}>
                        <img src={fileList?.[0]?.url} alt="profile" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "6px" }} />
                        <div onClick={() => { setFileList([]); setFile(null); if (isValidFuntion(updatePartnerUsersData)) setUpdateImage(true); }} title="Remove photo"
                          style={{ position: "absolute", top: 10, right: 10, background: "#720C20", borderRadius: "50%", width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff", fontSize: 15, fontWeight: "bold", boxShadow: "0 1px 4px rgba(0,0,0,0.25)", lineHeight: 1 }}>×</div>
                      </div>
                    );

                    if (cameraStream) return (
                      <div style={{ ...boxStyle, padding: "8px", display: "flex", flexDirection: "column", gap: "6px", overflow: "hidden" }}>
                        <video ref={videoRef} autoPlay playsInline muted
                          style={{ width: "100%", height: "100px", borderRadius: "6px", objectFit: "cover", display: "block", backgroundColor: "#000", flexShrink: 0 }} />
                        <canvas ref={canvasRef} style={{ display: "none" }} />
                        <div style={{ display: "flex", gap: "6px", flexShrink: 0 }}>
                          <button type="button" onClick={stopCamera}
                            style={{ flex: 1, height: "30px", background: "#fff", color: "#720C20", border: "1.5px solid #720C20", borderRadius: "6px", fontSize: "12px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                            Cancel
                          </button>
                          <button type="button" onClick={takeSelfie}
                            style={{ flex: 1, height: "30px", background: "#720C20", color: "#fff", border: "none", borderRadius: "6px", fontSize: "12px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                            Capture
                          </button>
                        </div>
                      </div>
                    );

                    const UploadSvg = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#720C20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" /><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" /></svg>;
                    const CameraSvg = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#720C20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" /><circle cx="12" cy="13" r="4" /></svg>;

                    return (
                      <div style={{ ...boxStyle, padding: "10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "8px" }}>
                        {[{ label: "Upload Photo", icon: <UploadSvg />, action: () => cameraInputRef.current?.click(), border: "1px solid rgba(114, 12, 32, 0.6)" },
                        { label: "Use Camera", icon: <CameraSvg />, action: startCamera, border: "1px solid rgb(221, 221, 221)" }]?.map(({ label, icon, action, border }) => (
                          <div key={label} onClick={action} style={{ ...btnRowStyle, border }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f9f0f1"}
                            onMouseLeave={e => e.currentTarget.style.background = "#fafafa"}>
                            <div style={iconBoxStyle}>{icon}</div>
                            <p style={{ margin: 0, fontWeight: "600", fontSize: "12px", color: "#222" }}>{label}</p>
                          </div>
                        ))}
                        <input ref={cameraInputRef} type="file" accept="image/jpeg,image/png" style={{ display: "none" }} onChange={handleGalleryUpload} />
                      </div>
                    );
                  })()}
                </Form.Item>
              </Col>

              <Col span={18} xs={24} md={18} lg={18} className="w-100">
                <Row className="w-100 mb-2">
                  <Col xs={24} md={12} lg={12}>
                    <Form.Item name="subtenantName" rules={[{ required: true, message: "Please select Firm" }]}>
                      <Select disabled={isValidFuntion(updatePartnerUsersData) || roleUserId != 4} placeholder="Firm" className="fs-7" dropdownMatchSelectWidth={false} onSelect={onSelectLifePointLaw}>
                        {subtenantdata?.map((dataprop) => (
                          <Option value={dataprop.subtenantName} key={dataprop.subtenantId}>
                            {dataprop.subtenantName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12} xs={24} md={12} lg={12} className="selectoffirmpartner">
                    <Form.Item name="subtenantRole"
                      rules={[{ required: true, message: "Please select role" }]}
                      getValueProps={() => ({ value: getSubtenantRoleId || [] })}>
                      <div ref={roleDropdownRef} style={{ position: "relative" }}>
                        <div
                          onClick={() => setOpenRoleDropdown(prev => !prev)}
                          style={{ border: "1px solid #474747", padding: "6px 12px", borderRadius: 2, display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", background: "#fff", fontSize: 14, minHeight: "44px" }}>
                          <span style={{ display: "flex", flexWrap: "wrap", gap: 4, flex: 1, overflow: "hidden" }}>
                            {(() => {
                              const selectedLabels = options
                                ?.filter(o => (getSubtenantRoleId || []).includes(parseInt(o.value)))
                                ?.map(o => o.label);
                              if (!selectedLabels?.length) {
                                return <span style={{ color: "#474747" }}>Role</span>;
                              }
                              return (
                                <>
                                  <span style={{ background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4, padding: "2px 8px", fontSize: 13, color: "#333", whiteSpace: "nowrap" }}>
                                    {selectedLabels[0]}
                                  </span>
                                  {selectedLabels?.length > 1 && (
                                    <span style={{ background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4, padding: "2px 8px", fontSize: 13, color: "#333", whiteSpace: "nowrap" }}>
                                      +{selectedLabels?.length - 1}
                                    </span>
                                  )}
                                </>
                              );
                            })()}
                          </span>
                          <span style={{ display: "inline-block", transition: "transform 0.2s", transform: openRoleDropdown ? "rotate(180deg)" : "rotate(0deg)", marginLeft: 8, flexShrink: 0 }}>
                            <img src="/black_select.svg" style={{ height: 16, width: 12 }} alt="" />
                          </span>
                        </div>

                        {openRoleDropdown && (
                          <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1px solid #d9d9d9", borderRadius: 6, boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000, maxHeight: 220, overflowY: "auto", padding: "4px 0" }}>
                            {options?.map(item => {
                              const val = parseInt(item?.value);
                              const isChecked = (getSubtenantRoleId || [])?.includes(val);
                              return (
                                <div key={item?.value} className="role-dropdown-item">
                                  <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: item?.disabled ? "not-allowed" : "pointer", opacity: item?.disabled ? 0.5 : 1, fontSize: 14, padding: "6px 12px", margin: 0 }}>
                                    <input style={{ height: "16px", width: "16px" }}
                                      type="checkbox"
                                      checked={isChecked}
                                      disabled={item?.disabled || false}
                                      className="checkBoxSize"
                                      onChange={() => {
                                        if (item?.disabled) return;
                                        const current = getSubtenantRoleId ? [...getSubtenantRoleId] : [];
                                        const updated = isChecked
                                          ? current?.filter(r => r !== val)
                                          : [...current, val];
                                        form.setFieldsValue({ subtenantRole: updated });
                                        getSubtenantId(updated);
                                      }}
                                    />
                                    {item?.label}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </Form.Item>
                  </Col>

                  <Col span={12} xs={24} md={12} lg={12}>
                    <Form.Item name="userSign">
                      <div className="signature-uploader-container">
                        {imageUrl ? (
                          <div className="container profileSign" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                            <img src={imageUrl} style={{ filter: isHovered ? 'blur(1px)' : 'none' }} alt="Uploaded Signature" className="uploaded-image" />
                            {isHovered && (
                              <div className="delete-icon" onClick={handleDeleteSign}>
                                <AiOutlineDelete />
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            <input type="file" accept="image/*" onChange={handleFileChange} ref={fileInputRef} style={{ display: 'none' }} />
                            <h6 style={{ height: "44px" }} onClick={handleClick} className="upload-button text-center">Upload Signature</h6>
                          </div>
                        )}
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div>
              <Row wrapperCol={{ span: 24 }} labelCol={{ span: 0 }} className="w-100" layout="inline">
                <PersonalInfo form={form} updatePartnerUsersData={updatePartnerUsersData} getMemberDetailsData={getMemberDetailsData} />

                {showConformationModal && <Confirmation
                  showConformationModal={showConformationModal}
                  setShowConformationModal={setShowConformationModal}
                  bodyContent={ConfirmationBodyContent}
                  ConsultationConfirm={ConsultationConfirm}
                />}

                {(getSubtenantRoleId || [])?.some(role => [3, 13, 14, 15].includes(role)) && (
                  <div className="w-100 mt-3" style={{ border: '1.5px dashed #720C20', borderRadius: '8px', padding: '12px' }}>
                    <Row className="w-100 d-flex" gutter={[8, 8]}>
                      <Col xs={11} md={11} lg={11}>
                        <p className="fw-bold mb-2" style={{ color: '#720C20', fontSize: '14px' }}>Consultation Charges</p>
                        <Form.Item name="charge" className="mt-1">
                          <Input type="text" prefix={<span style={{ fontSize: '14px' }}>$</span>} placeholder="0.00" />
                        </Form.Item>
                      </Col>
                      {(getSubtenantRoleId || [])?.some((role) => [13].includes(role)) && (
                        <Col xs={13} md={13} lg={13}>
                          <p className="fw-bold mb-2" style={{ color: '#720C20', fontSize: '14px' }}>WSBA Number (Washington State Bar Association)</p>
                          <Form.Item name="wsbaNumber" className="mt-1">
                            <Input type="text" placeholder="Washington State Bar Association"
                              onInput={(e) => (e.target.value = e.target.value.toUpperCase())} />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </div>
                )}

                <div className="w-100 mt-3" style={{ border: '1.5px dashed #720C20', borderRadius: '8px', padding: '12px' }}>
                  <p className="fw-bold mb-2" style={{ color: '#720C20', fontSize: '14px' }}>Contact Address</p>
                  <Address form={form} updatePartnerUsersData={updatePartnerUsersData} setAddressAPIStatus={setAddressAPIStatus} selectedSubtenantAddress={selectedSubtenantAddress} />
                </div>
              </Row>

              <div>
                <div className="w-100 mt-3" style={{ border: '1.5px dashed #720C20', borderRadius: '8px', padding: '12px' }}>
                  <p className="fw-bold mb-2" style={{ color: '#720C20', fontSize: '14px' }}>Contact Information</p>
                  <Row className="mt-1" gutter={[8, 0]}>
                    <Col className="mt-2" lg={12} xs={24} span={12}>
                      <Form.Item name="email" rules={[{ type: "email", required: true, message: "Please enter your E-mail" }]}>
                        <Input placeholder="Email" disabled={(updatePartnerUsersData !== undefined && updatePartnerUsersData !== null && updatePartnerUsersData !== "") ? true : false} />
                      </Form.Item>
                    </Col>
                    <Col className="mt-2" lg={12} xs={24} span={12}>
                      <Form.Item name="mobile" className="me-1" rules={[{ required: true, message: "Please enter your phone number" }]}>
                        <PhoneInput
                          country="us"
                          preferredCountries={['us']}
                          value={form.getFieldsValue().mobile}
                          onChange={(value, country) => onChangePhone(value, country)}
                          countryCodeEditable={false}
                          inputStyle={{ width: '100%', height: '44px' }}
                          containerStyle={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>

                <div className="w-100 mt-3" style={{ border: '1.5px dashed #720C20', borderRadius: '8px', padding: "12px 18px 12px 12px", marginBottom: "19px" }}>
                  <p className="fw-bold mb-2" style={{ color: '#720C20', fontSize: '14px' }}>Client Email (if the staff member is also a client)</p>
                  <div className="mt-2 justify-content-start">
                    <div className="mt-2" lg={12} xs={24} span={12}>
                      <div className="d-flex align-items-center">
                        <div className={`input-group cleintsEmailInput ${(clents_email_error && clientsEmailList?.length > 0) ? "borderRed" : ""}`}>
                          <input type="text" id="clients_Email" name="clients_Email" placeholder="Enter clients email"
                            aria-label="Username" aria-describedby="basic-addon1" value={clientsEmail}
                            onChange={cleintsEmailFun} onKeyDown={onKeyDownEvent} />
                          <div className="input-group-append">
                            <span className="input-group-text" id="basic-addon1">
                              <img src={`${(clientsEmail.length > 0) ? "./images/crossIcon.svg" : "/search icon.png"}`}
                                style={{ height: "12px", width: "13px", filter: clientsEmail.length > 0 ? "brightness(0) saturate(100%) invert(27%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(50%)" : "none" }}
                                alt="Cross Icon" className="cursor-pointer"
                                id={`${(clientsEmail.length > 0) ? "crossIcon" : "searchIcon"}`}
                                onClick={removeEmailContent} />
                            </span>
                          </div>
                        </div>
                        <button type="button" className="btn btn-light ms-2 fw-bold"
                          style={{ whiteSpace: "nowrap", height: "44px", borderColor: "#720C20", color: "#720C20", background: "#fff", borderRadius: "2px" }}
                          onClick={SearchClientsEmail}>Search</button>
                      </div>

                      {clents_email_error && clientsEmail?.length > 0 && <span className="invalid_Clients_email_message">Please enter a valid clients E-mail</span>}
                      {!clents_email_error && registeredEmailState && <span className="invalid_Clients_email_message">Entered email not registered in portal</span>}
                      {registerdButDiffrentRole && !clents_email_error && <span className="invalid_Clients_email_message">Entered email is not registered as a client</span>}

                      {clientsEmailList?.length > 0 && (
                        <div className="mt-1">
                          {clientsEmailList?.map((data) => (
                            <div key={data?.staffAsClientUserId}
                              className={`${(data?.checked == true) ? "project_color text-white" : "bg-grey"} clientsListPara cursor-pointer`}
                              id={data?.staffAsClientUserId} value={data?.emailId}
                              onClick={(event) => selectStaffEmail(event, data)}>
                              <h1 className={`${(data?.checked == true) ? "text-white" : ""}`}>{data?.userFullName}</h1>
                              <p><span className="font-semibold text-sm block leading-tight">{data?.emailId}</span></p>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="mt-1">
                        {(clientsEmailListChecked?.length > 0) && clientsEmailListChecked?.map((data) => (
                          <section key={data?.id}
                            className="project_color text-white clientsListPara cursor-pointer"
                            id={data?.id} value={data?.emailId}>
                            <div className="d-flex justify-content-between">
                              <h1 className="text-white">{data?.userFullName}</h1>
                              <button onClick={(event) => { removeCheckedStaff(event, data) }} id={data?.id} className="btn btn-transparent">
                                <img src="./images/crossIcon.svg" alt="Cross Icon" className="cursor-pointer" id="crossIcon" />
                              </button>
                            </div>
                            <p><span className="font-semibold text-sm block leading-tight">{data?.emailId}</span></p>
                          </section>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {getSubtenantRoleId?.includes(7) && (
                <div className="w-100 mt-3" style={{ border: '1.5px dashed #720C20', borderRadius: '8px', padding: '12px' }}>
                  <p className="fw-bold mb-2" style={{ color: '#720C20', fontSize: '14px' }}>About</p>
                  <Row className="mt-1" gutter={[0, 8]}>
                    <Col className="mt-2" lg={24} xs={24} span={24}>
                      <Form.Item name="speakerLink" rules={[{ required: true, message: "Please Enter Speaker Link" }]}>
                        <Input placeholder="Enter Link" />
                      </Form.Item>
                    </Col>
                    <Col className="mt-2" lg={24} xs={24} span={24}>
                      <Form.Item name="speakerDescription" rules={[{ required: true, message: "Please Enter Speaker Description!" }]}>
                        <TextArea placeholder="Speaker Description" rows={4} />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}
            </div>

            <Row className="mt-3 w-100" style={{ borderTop: "1px solid #BFBFBF", paddingTop: "24px" }}>
              <Col className="w-100 d-flex justify-content-end" style={{ gap: '8px' }}>
                <Button className="fw-bold" onClick={onCancel}
                  style={{ color: "#720C20", borderColor: "#720C20", borderRadius: "2px", height: "44px", minWidth: "90px" }}>
                  Cancel
                </Button>

                <Button
                  className="fw-bold"
                  htmlType="submit"
                  disabled={submitting}
                  style={{
                    background: submitting ? "#8E1630" : "#720C20",
                    color: "white",
                    borderRadius: "2px",
                    height: "44px",
                    minWidth: "90px",
                    cursor: submitting ? "not-allowed" : "pointer",
                    opacity: submitting ? 0.7 : 1,
                  }}
                >
                  {submitting
                    ? (!isNullUndefine(updatePartnerUsersData) ? "Updating…" : "Saving…")
                    : (!isNullUndefine(updatePartnerUsersData) ? "Update" : "Save")
                  }
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      {showDeleteModal == true && (
        <DeleteConfirmModal
          visible={showDeleteModal}
          hideModal={setShowDeleteModal}
          titleText="Delete Role"
          bodyContent={`Do you want to delete "${deletedRoleName}" ${deletedRoleName.split(",").length == 1 ? "role" : "roles"} for this user?`}
          deleteStatus={deletestatus}
        />
      )}
    </>
  )
}

export default AddSubtenantUsers
